
(function() {
    'use strict';
    
    angular
    	.module('serviciosocialApp')
    	.factory('AcuseDownloadService', AcuseDownloadService);

    AcuseDownloadService.$inject = ['$q','$http'];
    
        function AcuseDownloadService($q, $http) {
        	return {
        		download: download
        	}
        			
        	function download(idProyecto) {
	        	var defer = $q.defer();
	                
	            $http({
					url: 'api/s-s-proyectos/acuse/'+ idProyecto,
					method : 'POST',
					params : {},
					headers : {
						'Content-type' : 'application/octet-stream',
					},
					responseType : 'arraybuffer'
	            }).success(function(data, status, headers, config) {
					var file = new Blob([ data ], {
						type : 'application/pdf'
					});
					//trick to download store a file having its URL
					var fileURL = URL.createObjectURL(file);
					var a         = document.createElement('a');
					a.href        = fileURL; 
					a.target      = '_blank';
					a.download    = "AcuseServicioSocial_" + idProyecto;
					document.body.appendChild(a);
					a.click();
					defer.resolve('success');
	            }).error(function() {
					defer.reject('error');
				});
	            return defer.promise;
	        };
        }
})();